import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Loading from "../Components/Loading";
import { useEffect, useState } from "react";
import * as api from "../api/api";
import { Snackbar, Alert } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import checkAuthorization from "../config/checkAuth";
import { useLanguage } from "../Components/Localization/LanguageContext";
import strings from "../Components/Localization/strings";

export default function OutboundVDNs() {
  const { language } = useLanguage();
  const pageTitle = "OutboundVDNs";

  const handleCloseAddModal = () => setShowAddModal(false);
  const handleCloseEditModal = () => setShowEditModal(false);

  const [isLoading, setIsLoading] = useState(true);
  const [showAddModal, setShowAddModal] = useState(false);
  const [allOutboundVdns, setAllOutboundVdns] = useState([]);
  const [lobs, setLobs] = useState([]);
  const [showEditModal, setShowEditModal] = useState(false);
  const [isValidEditVdn, setIsValidEditVdn] = useState(true);
  const [vdnToEdit, setVdnToEdit] = useState({});
  const [showConfirmDeleteModal, setShowConfirmDeleteModal] = useState(false);
  const [vdnToDeleteId, setVdnToDeleteId] = useState("");
  const [errorSnackbar, setErrorSnackbar] = useState(false);
  const [invalidNumberSnackbar, setInvalidNumberSnackbar] = useState(false);
  const [successSnackbar, setSuccessSnackbar] = useState(false);
  const [snackbarData, setSnackbarData] = useState({});

  const navigate = useNavigate();

  function getAllLobs() {
    api.getAllLobs().then((response) => {
      setLobs(response.data.object);
    });
  }

  function getAllOutboundVDNs() {
    api.getAllOutboundVdns().then((response) => {
      setAllOutboundVdns(response.data.object);
      //console.log(response.data.object);
    });
  }

  function addOutboundVdn(event) {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      const newOutboundVdnData = {
        name: form.name.value,
        vdn: form.vdn.value,
        phoneNumber: form.phoneNumber.value,
        lineOfBusiness: form.lob.value,
        isDefault: form.isDefaultNumber.checked,
      };

      //check if there exists a default
      event.preventDefault();
      event.stopPropagation();

      // map alloutboundvdns to tenants
      const resultArray = allOutboundVdns.reduce((accumulator, currentItem) => {
        const existingEntry = accumulator.find(
          (entry) => entry.tenantId === currentItem.tenantId
        );
        if (existingEntry) {
          existingEntry.hasDefault =
            existingEntry.hasDefault || currentItem.isDefault;
        } else {
          accumulator.push({
            tenantId: currentItem.tenantId,
            hasDefault: currentItem.isDefault,
          });
        }
        return accumulator;
      }, []);

      const doesHaveDefault = resultArray.some(
        (entry) =>
          entry.tenantId === newOutboundVdnData.tenantId && entry.hasDefault
      );

      console.log(doesHaveDefault);
      // we'll branch from here, if it does have a default, we'll need to do some extra checks
      if (doesHaveDefault === true) {
        // if trying to remove it as default, thats ok
        if (newOutboundVdnData.isDefault === false) {
          console.log("ok to proceed");

          api
            .addNewOutboundVdn(newOutboundVdnData)
            .then((response) => {
              console.log(response);

              if (response.data.statusCode == 400) {
                setSnackbarData({
                  ...snackbarData,
                  message: response.data.message,
                  show: true,
                  severity: "error",
                });
              } else {
                getAllOutboundVDNs();
                setShowAddModal(false);
                if (response.data.statusCode == 200) {
                  setSuccessSnackbar(true);
                }
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else if (newOutboundVdnData.isDefault === true) {
          console.log("incorrect");
          setErrorSnackbar(true);
        }
      } else {
        api
          .addNewOutboundVdn(newOutboundVdnData)
          .then((response) => {
            console.log(response);

            if (response.data.statusCode == 400) {
              setSnackbarData({
                ...snackbarData,
                message: response.data.message,
                show: true,
                severity: "error",
              });
            } else {
              getAllOutboundVDNs();
              setShowAddModal(false);
              if (response.data.statusCode == 200) {
                setSuccessSnackbar(true);
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    }
  }

  function handleEditVdn(vdn) {
    console.log(vdn);
    setVdnToEdit(vdn);
    setShowEditModal(true);
  }

  function editOutboundVdn(event) {
    const form = event.currentTarget;
    console.log(form.checkValidity(), isValidEditVdn);
    if (form.checkValidity() === false || isValidEditVdn === false) {
      event.preventDefault();
      event.stopPropagation();
      console.log("error");
    } else {
      //check if there exists a default
      console.log(form, allOutboundVdns);
      event.preventDefault();
      event.stopPropagation();

      // Check if the current tenant already has a default
      const doesHaveDefault = allOutboundVdns.find((entry) => entry.isDefault);

      console.log("vdn to edit: ", vdnToEdit);

      console.log(doesHaveDefault);
      // we'll branch from here, if it does have a default, we'll need to do some extra checks
      if (doesHaveDefault !== undefined) {
        // if trying to remove it as default, thats ok
        if (
          vdnToEdit.isDefault === false ||
          (vdnToEdit.isDefault === true &&
            doesHaveDefault.outboundVdnId === vdnToEdit.outboundVdnId)
        ) {
          console.log("ok to proceed");
          api
            .modifyOutboundVdn(vdnToEdit.outboundVdnId, vdnToEdit)
            .then((response) => {
              console.log(response);
              setShowEditModal(false);
              getAllOutboundVDNs();
              if (response.data.statusCode == 200) {
                setSuccessSnackbar(true);
              }
            })
            .catch((error) => console.log(error));
        } else {
          console.log("incorrect");
          setErrorSnackbar(true);
        }
      } else {
        api
          .modifyOutboundVdn(vdnToEdit.outboundVdnId, vdnToEdit)
          .then((response) => {
            console.log(response);
            setShowEditModal(false);
            getAllOutboundVDNs();
            setSuccessSnackbar(true);
          })
          .catch((error) => console.log(error));
      }
    }
  }

  function deleteOutboundVdn(id) {
    console.log(id);

    api.deleteOutboundVdn(id).then((response) => {
      console.log(response);
      setShowConfirmDeleteModal(false);
      getAllOutboundVDNs();
      setSuccessSnackbar(true);
    });
  }

  // This function contains a regex that matches the phone number according to their specifications in the document
  // once we have a way to validate, we can use this

  function changeVdnToEdit(event) {
    let fieldName = event.target.name;
    let fieldValue = event.target.value;

    // edge case for the checkbox
    if (fieldName === "isDefault") {
      fieldValue = event.target.checked;
    }

    console.log(fieldName, fieldValue);

    setVdnToEdit({ ...vdnToEdit, [fieldName]: fieldValue });
  }

  useEffect(() => {
    // call function to load content then set isloading to false

    checkAuthorization("OUTBOUND_LINE").then((result) => {
      if (result) {
        if (isLoading) {
          getAllOutboundVDNs();
          getAllLobs();
          setIsLoading(false);
        } else {
        }
      } else {
        navigate("/unauthorized");
      }
    });
  }, [isLoading]);

  return (
    <>
      <div className="main-content">
        <p className="main-content__title">
          {strings[pageTitle][language].pageName}
        </p>
        <hr className="main-content-title__hr" />
        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          open={snackbarData.show}
          autoHideDuration={3000}
          onClose={() => setSnackbarData({ ...snackbarData, show: false })}
        >
          <Alert severity={snackbarData.severity}>{snackbarData.message}</Alert>
        </Snackbar>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "row",
          }}
        >
          <div>
            <button
              className="btn btn-outline-primary"
              style={{ marginRight: 10 }}
              hidden="hidden"
            >
              Move Up
            </button>

            <button className="btn btn-outline-primary" hidden="hidden">
              Move Down
            </button>
          </div>

          <button
            className="btn btn-outline-primary"
            onClick={() => {
              setShowAddModal(true);
            }}
          >
            {strings[pageTitle][language].add}
          </button>
        </div>

        {isLoading ? (
          <Loading></Loading>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "row",
            }}
          >
            <table
              style={{
                width: "100%",
                marginTop: 20,
                border: "none",
              }}
            >
              <thead>
                <tr align={"left"}>
                  <th>{strings[pageTitle][language].tableHeaders[0]}</th>
                  <th>{strings[pageTitle][language].tableHeaders[1]}</th>
                  <th>{strings[pageTitle][language].tableHeaders[2]}</th>
                  <th>{strings[pageTitle][language].tableHeaders[3]}</th>
                  <th>{strings[pageTitle][language].tableHeaders[4]}</th>
                  <th>{strings[pageTitle][language].tableHeaders[5]}</th>
                </tr>
              </thead>
              <tbody>
                {allOutboundVdns.map((vdn) => {
                  return (
                    <tr key={vdn.name}>
                      <td>{vdn.name}</td>
                      <td>{vdn.vdn}</td>
                      <td>{vdn.phoneNumber}</td>
                      <td>
                        {vdn.isDefault
                          ? strings[pageTitle][language].yes
                          : strings[pageTitle][language].no}
                      </td>
                      <td>{vdn.lineOfBusiness}</td>
                      <td style={{ display: "flex" }} align="center">
                        <button
                          onClick={() => {
                            handleEditVdn(vdn);
                          }}
                          style={{
                            border: "none",
                            outline: "none",
                            backgroundColor: "rgba(255, 0, 0, 0)",
                            color: "#00a0e5",
                          }}
                          className="icon-btn"
                        >
                          <EditIcon></EditIcon>
                        </button>
                        <button
                          onClick={() => {
                            setShowConfirmDeleteModal(true);
                            setVdnToDeleteId(vdn.outboundVdnId);
                          }}
                          style={{
                            border: "none",
                            outline: "none",
                            backgroundColor: "rgba(255, 0, 0, 0)",
                            color: "#00a0e5",
                          }}
                          className="icon-btn"
                        >
                          <DeleteIcon></DeleteIcon>
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>

      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={errorSnackbar}
        autoHideDuration={3000}
        onClose={() => setErrorSnackbar(false)}
      >
        <Alert severity={"error"}>
          {strings[pageTitle][language].errorEditingVDN}
        </Alert>
      </Snackbar>

      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={successSnackbar}
        autoHideDuration={3000}
        onClose={() => setSuccessSnackbar(false)}
      >
        <Alert severity={"success"}>
          {strings[pageTitle][language].actionSuccessful}
        </Alert>
      </Snackbar>

      <Modal show={showAddModal} onHide={handleCloseAddModal}>
        <Form onSubmit={addOutboundVdn}>
          <Modal.Body>
            <b>{strings[pageTitle][language].addNewOutboundQueue}</b>
            <Form.Group className="mb-3">
              <Form.Label>{strings[pageTitle][language].name}</Form.Label>
              <Form.Control
                placeholder=""
                autoFocus
                required
                type="text"
                name="name"
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>{strings[pageTitle][language].queue}</Form.Label>
              <Form.Control placeholder="" required type="text" name="vdn" />
            </Form.Group>
            <Form.Group className="mb-3" controlId="phoneNumber">
              <Form.Label>{strings[pageTitle][language].telNo}</Form.Label>
              <Form.Control placeholder="" type="string" name="phoneNumber" />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>{strings[pageTitle][language].default}</Form.Label>
              <Form.Check placeholder="" name="isDefaultNumber" />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>{strings[pageTitle][language].lob}</Form.Label>
              <Form.Select aria-label="Default select example" name="lob">
                <option> </option>

                {lobs.map((lob) => {
                  return (
                    <option value={lob.name} key={lob.id}>
                      {lob.name}
                    </option>
                  );
                })}
              </Form.Select>
            </Form.Group>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="light" onClick={handleCloseAddModal}>
              {strings[pageTitle][language].cancel}
            </Button>
            <Button variant="primary" type="submit">
              {strings[pageTitle][language].add}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      <Modal
        show={showEditModal}
        onHide={() => {
          setShowEditModal(false);
        }}
      >
        <Form onSubmit={editOutboundVdn} noValidate validated={isValidEditVdn}>
          <Modal.Body>
            <b>{strings[pageTitle][language].editOutboundQueue}</b>
            <Form.Group className="mb-3">
              <Form.Label>{strings[pageTitle][language].name}</Form.Label>
              <Form.Control
                defaultValue={vdnToEdit.name}
                autoFocus
                required
                type="text"
                name="name"
                onChange={(event) => {
                  changeVdnToEdit(event);
                }}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>{strings[pageTitle][language].queue}</Form.Label>
              <Form.Control
                defaultValue={vdnToEdit.vdn}
                required
                type="text"
                name="vdn"
                onChange={(event) => changeVdnToEdit(event)}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>{strings[pageTitle][language].telNo}</Form.Label>
              <Form.Control
                defaultValue={vdnToEdit.phoneNumber}
                type="string"
                name="phoneNumber"
                onChange={(event) => {
                  changeVdnToEdit(event);
                }}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>{strings[pageTitle][language].default}</Form.Label>
              <Form.Check
                defaultChecked={vdnToEdit.isDefault ? "on" : ""}
                name="isDefault"
                onChange={(event) => changeVdnToEdit(event)}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>{strings[pageTitle][language].lob}</Form.Label>
              <Form.Select
                aria-label="Default select example"
                name="lineOfBusiness"
                defaultValue={vdnToEdit.lineOfBusiness}
                onChange={(event) => changeVdnToEdit(event)}
              >
                <option> </option>

                {lobs.map((lob) => {
                  return (
                    <option value={lob.name} key={lob.id}>
                      {lob.name}
                    </option>
                  );
                })}
              </Form.Select>
            </Form.Group>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="light" onClick={handleCloseEditModal}>
              {strings[pageTitle][language].cancel}
            </Button>
            <Button variant="primary" type="submit">
              {strings[pageTitle][language].confirm}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={invalidNumberSnackbar}
        autoHideDuration={3000}
        onClose={() => setInvalidNumberSnackbar(false)}
      >
        <Alert severity={"error"}>
          {strings[pageTitle][language].invalidPhoneNumber}
        </Alert>
      </Snackbar>

      <Modal show={showConfirmDeleteModal}>
        <Modal.Body>
          <p>{strings[pageTitle][language].areYouSureToDelete}</p>
          <Modal.Footer>
            <Button
              variant="light"
              onClick={() => {
                setShowConfirmDeleteModal(false);
              }}
            >
              {strings[pageTitle][language].cancel}
            </Button>
            <Button
              variant="danger"
              onClick={() => deleteOutboundVdn(vdnToDeleteId)}
            >
              {strings[pageTitle][language].confirm}
            </Button>
          </Modal.Footer>
        </Modal.Body>
      </Modal>
    </>
  );
}
